import { IntlShape } from 'react-intl'
import type { AdditionalInformation } from 'typings'
import { create, each, enforce, omitWhen, test } from 'vest'
import { BASE_PATH, fieldName } from './Editor'
import { messages } from './messages'

type FormData = {
  [BASE_PATH]: AdditionalInformation[]
}

function isEmptyForm(entries: AdditionalInformation[]) {
  return entries.length === 1 && !entries[0].name && !entries[0].value
}

function isUniqueName(names: string[], name: string) {
  return names.filter((key) => key === name)?.length === 1
}

export function buildValidationSuite(intl: IntlShape) {
  const { formatMessage: i18n } = intl
  const { validation } = messages

  return create((data: FormData) => {
    const entries = data[BASE_PATH]
    const names = entries.flatMap((e) => e.name)

    omitWhen(
      () => isEmptyForm(entries),
      () =>
        each(entries, (entry, index) => {
          test(fieldName(index, 'name'), i18n(validation.required), () => {
            enforce(entry.name.trim()).isNotEmpty()
          })

          test(fieldName(index, 'name'), i18n(validation.unique), () => {
            enforce(entry.name).condition((name) => isUniqueName(names, name))
          })

          test(fieldName(index, 'value'), i18n(validation.required), () => {
            enforce(entry.value.trim()).isNotEmpty()
          })
        })
    )
  })
}
